import React, { useReducer, createContext, useEffect } from "react";
import {
  Routes,
  Route,
  HashRouter,
  useLocation,
  BrowserRouter,
  Navigate,
} from "react-router-dom";
import { NavLinkProvider } from "./context/NavLinkContext";
import ReactGA from "react-ga4";

// css
import "./App.css";
// import "~slick-carousel/slick/slick.css";
// import "~slick-carousel/slick/slick-theme.css";

// components
import Navbar from "./components/navbar/Navbar";
import LoginPage from "./components/Login/LoginPage";
import PageOne from "./containers/PageOne";
import DiWrapper from "./containers/DiWrapper";
import InvestmentsWrapper from "./containers/InvestmentsWrapper";
import PerformanceWrapper from "./containers/PerformanceWrapper";
import InvestorRelationsWrapper from "./containers/InvestorRelationsWrapper";
import TeamWrapper from "./containers/TeamWrapper";
import ScrollToTop from "./containers/ScrollToTop";
import HelmetMeta from "./components/Helmet/HelmetMeta";

// Auth Context will pass the auth state from this component to any other component that needs it.
export const AuthContext = createContext();
const initialState = {
  isAuthenticated: true,
  user: null,
  token: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
      };
    case "LOGOUT":
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };
    default:
      return state;
  }
};

// Track page views on route changes
const usePageTracking = () => {
  const location = useLocation();

  // useEffect(() => {
  //   ReactGA.send({ hitType: "pageview", page: location.pathname });
  // }, [location]);
  useEffect(() => {
    const currentPath = `${location.pathname}${location.hash}`;
    ReactGA.send({ hitType: "pageview", page: currentPath });
    // console.log("GA Page View Sent: ", currentPath);
  }, [location]);
};

// Separate component to track page views
const PageTracker = () => {
  usePageTracking();
  return null;
};

function App() {
  const password = process.env.REACT_APP_PASS;
  const envType = process.env.REACT_APP_TYPE;
  const [state, dispatch] = useReducer(reducer, initialState);

  const renderLogin = () => {
    if (envType === "test") {
      return (
        <BrowserRouter>
          <AuthContext.Provider value={{ state, dispatch }}>
            <NavLinkProvider>
              <Navbar />
              <ScrollToTop>
                <HelmetMeta />
                <PageTracker />
                <Routes>
                  <Route path="/" element={<Navigate to="/home" replace />} />
                  <Route exact path="/home" element={<PageOne />} />
                  <Route
                    exact
                    path="/digitalinfrastructure"
                    element={<DiWrapper />}
                  />
                  <Route
                    exact
                    path="/investments"
                    element={<InvestmentsWrapper />}
                  />
                  <Route
                    exact
                    path="/performance"
                    element={<PerformanceWrapper />}
                  />
                  <Route
                    exact
                    path="/investorrelations"
                    element={<InvestorRelationsWrapper />}
                  />
                  <Route exact path="/team" element={<TeamWrapper />} />
                </Routes>
              </ScrollToTop>
            </NavLinkProvider>
          </AuthContext.Provider>
        </BrowserRouter>
      );
    } else {
      return (
        <BrowserRouter>
          <AuthContext.Provider value={{ state, dispatch }}>
            <NavLinkProvider>
              <Navbar />
              <ScrollToTop>
                <HelmetMeta />
                <PageTracker />
                <Routes>
                  <Route path="/" element={<Navigate to="/home" replace />} />
                  <Route exact path="/home" element={<PageOne />} />
                  <Route
                    exact
                    path="/digitalinfrastructure"
                    element={<DiWrapper />}
                  />
                  <Route
                    exact
                    path="/investments"
                    element={<InvestmentsWrapper />}
                  />
                  <Route
                    exact
                    path="/performance"
                    element={<PerformanceWrapper />}
                  />
                  <Route
                    exact
                    path="/investorrelations"
                    element={<InvestorRelationsWrapper />}
                  />
                  <Route exact path="/team" element={<TeamWrapper />} />
                </Routes>
              </ScrollToTop>
            </NavLinkProvider>
          </AuthContext.Provider>
        </BrowserRouter>
      );
    }
  };

  return <div className="App">{renderLogin()}</div>;
}

export default App;
